import "../styles/style.scss";
import './helpers/polyfills';

// Neos Sitegeist.Lazybones required lazysizes to be bundled
import 'lazysizes';

// custom
import "./helpers/vh";
import "./component/navigation";
import Scrollbar from "./helpers/scrollbarWidth";
import Slider from "./component/slider";
import Map from './component/map';
import Bookmarks from "./component/bookmarks";
// @todo see below, temporarily disabled
// import YTApiHandler from "./component/video-slide";
import initHeroTitleAnimation from "./component/hero-title-animation";
import initContentParallax from "./component/content";
import initHeaderParallax from "./component/header";
import GoogleMaps from "./component/google-maps";
import Gallery from "./component/gallery";
import Form from "./component/form";
//initializations

// init application
class App {
  constructor() {
    // scrollbar with detection
    new Scrollbar();

    //bookmark handler
    new Bookmarks();

    // parallax's
    initContentParallax();
    initHeaderParallax();

    // init hero title animation
    initHeroTitleAnimation();

    // sliders init
    window.sliders = [];
    Array.prototype.forEach.call(document.querySelectorAll('.glide'), (el) => {
      window.sliders.push(new Slider(el));
    });

    // youtube api init and handler
    // @todo das ist notwendig für Videos in Slides
    // mit Kunden abklären ob das noch notwendig ist (wegen DSGVO), sonst entfernen
    // YTApiHandler();

    new GoogleMaps();

    // lightbox (photoswipe)
    // new Gallery('.gallery a');
    new Gallery('.section__gallery figure');

    // swatches fix
    let swatchBounding = () => {
      Array.prototype.forEach.call(document.querySelectorAll('.product-swatches li span'), el => {
        el.classList[el.getBoundingClientRect().right > window.innerWidth ? 'add' : 'remove']('right');
      });
    }
    window.addEventListener('load', swatchBounding)

    Form.init();
  }
}

new App();
